import { useEffect, useState } from "react";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { EMPTY_POST, PostForm, toLocalDT, type PostFormValues } from "@/components/admin/PostForm";

export const Route = createFileRoute("/_authenticated/admin/artigos/$id")({
  component: PostEditorRoute,
});

function PostEditorRoute() {
  const { id } = useParams({ from: "/_authenticated/admin/artigos/$id" });
  const isNew = id === "novo";
  const [initial, setInitial] = useState<PostFormValues | null>(isNew ? EMPTY_POST : null);
  const [cats, setCats] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    void (async () => {
      const { data: c } = await supabase.from("categories").select("id,name").order("sort_order");
      setCats((c ?? []) as { id: string; name: string }[]);
      if (isNew) {
        setInitial(EMPTY_POST);
        return;
      }
      const { data } = await supabase.from("posts").select("*").eq("id", id).maybeSingle();
      if (!data) {
        setInitial(EMPTY_POST);
        return;
      }
      const d = data as unknown as Record<string, unknown>;
      setInitial({
        id: String(d["id"]),
        h1_title: String(d["h1_title"] ?? ""),
        slug: String(d["slug"] ?? ""),
        excerpt: String(d["excerpt"] ?? ""),
        content_html: String(d["content_html"] ?? ""),
        cover_image_url: String(d["cover_image_url"] ?? ""),
        cover_image_alt: String(d["cover_image_alt"] ?? ""),
        category_id: String(d["category_id"] ?? ""),
        seo_title: String(d["seo_title"] ?? ""),
        meta_description: String(d["meta_description"] ?? ""),
        focus_keyword: String(d["focus_keyword"] ?? ""),
        canonical_url: String(d["canonical_url"] ?? ""),
        allow_indexing: d["allow_indexing"] !== false,
        allow_following: d["allow_following"] !== false,
        status: ((d["status"] as string) === "trash" ? "draft" : (d["status"] as PostFormValues["status"])) ?? "draft",
        published_at: toLocalDT(d["published_at"] as string | null),
      });
    })();
  }, [id, isNew]);

  if (!initial) return <div className="kk-cms__page">Carregando…</div>;

  return <PostForm key={initial.id ?? "novo"} initial={initial} categories={cats} />;
}
